import { IGroupedComboBoxIconProps } from 'grouped-combobox-core';

export const iconNames = {
    empty: '',
    premium: 'Diamond-svg',
    info: 'Info-svg',
    warning: 'WarningLarge-svg',
    warningInTextField: 'WarningSmall-svg',
    pin: 'Pinned-svg',
    pinned: 'PinnedSolid-svg',
};

export const emptyIconProps: IGroupedComboBoxIconProps = {
    source: iconNames.empty,
};
